import { ChangeDetectionStrategy, Component, computed, input, viewChild } from '@angular/core';
import { UploadProgressLineComponent } from './upload-progress-line.component';

/**
 * The editor's upload indicator: the SAME shared bar the wizard and Photos page mount, hosted in a strip
 * under the top bar. The strip reserves its own height only while the bar is visible — it eases open as
 * the upload starts and eases shut once the bar has collapsed, so the surface temporarily makes room and
 * then gives it back. One loader, one behaviour, at every upload entry point.
 */
@Component({
  selector: 'app-editor-upload-progress-strip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UploadProgressLineComponent],
  host: {
    class: 'grid flex-none overflow-hidden transition-[grid-template-rows] duration-[var(--t-mid)] ease-[var(--ease-smooth)]',
    '[style.gridTemplateRows]': "expanded() ? '1fr' : '0fr'",
  },
  styles: [
    `
      @media (prefers-reduced-motion: reduce) {
        :host {
          transition: none;
        }
      }
    `,
  ],
  template: `
    <div class="min-h-0 overflow-hidden bg-panel">
      <app-upload-progress-line [projectId]="projectId()" [showPhaseWord]="false" class="block px-4 py-2" />
    </div>
  `,
})
export class EditorUploadProgressStripComponent {
  readonly projectId = input<string | null>(null);

  private readonly line = viewChild(UploadProgressLineComponent);

  protected readonly expanded = computed(() => this.line()?.visible() ?? false);
}
